import {Component, OnInit} from '@angular/core';
import {Input} from '@angular/core';
import {UploadFile} from 'ng-zorro-antd';
import {NzMessageService} from 'ng-zorro-antd';
import {SystemContants} from '@core/constants';
import {_HttpClient} from '@delon/theme';
import {NzModalRef} from 'ng-zorro-antd';
import {UtilServiceService} from '@shared/service/util-service.service';
import {ChangeDetectorRef} from '@angular/core';
import {ModalHelper} from '@delon/theme';
import {NzModalService} from 'ng-zorro-antd';
import {ViewChild} from '@angular/core';
import {TemplateRef} from '@angular/core';

declare var window: any;
declare var navigator: any;

@Component({
  selector: 'app-contract-image',
  templateUrl: './contract-image.component.html',
  styles: []
})
export class ContractImageComponent implements OnInit {

  @Input()
  record: any = {};

  uploadAction: any = null;
  uploading: boolean = false;
  showCamera: boolean = false;
  images: any[] = [];
  video: any = null;
  currentImage: any = null;

  @ViewChild("maxImage")
  maxImageTpl: TemplateRef<any>;

  constructor(private msg: NzMessageService,
              private changeDetectorRef: ChangeDetectorRef,
              private modalService: NzModalService,
              private http: _HttpClient,
              private utilService: UtilServiceService) {
  }

  ngOnInit() {
    this.uploadAction = 'api/app/contract/upload/image/contract/' + this.record.id;
    this.images = this.record.images;
  }

  toCamera() {
    var that = this;
    var video: any = document.getElementById('video');
    this.video = video;
    try {
      //媒体对象
      navigator.getMedia = navigator.getUserMedia || navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia || navigator.msGetUserMedia;
      navigator.getMedia({
        video: true, //使用摄像头对象
        audio: false  //不适用音频
      }, function (strem) {
        video.srcObject = strem;
        that.utilService.mediaStream = strem;
        video.play();
        that.showCamera = true;
        that.changeDetectorRef.detectChanges();


      }, function (error) {
        that.showCamera = false;
        that.changeDetectorRef.detectChanges();
        that.msg.error('请使用最新版本的谷歌浏览器');
      });
    } catch (e) {
      that.showCamera = false;
      that.changeDetectorRef.detectChanges();
      that.msg.error('请使用最新版本的谷歌浏览器');
    }

  }

  beforeUpload = (fileUpload: UploadFile, fileList: UploadFile[]) => {
    let canUpload = true;
    fileList.forEach((file) => {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
      if (!isJPG) {
        this.msg.error('只能上传jpg和png图片');
        canUpload = false;
        return;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.msg.error('单张图片必须小于2M');
        canUpload = false;
        return;
      }
    });
    return canUpload;
  };

  onUploadStatusChange(info: { file: UploadFile }) {
    switch (info.file.status) {
      case 'uploading':
        this.uploading = true;
        break;
      case 'done':
        if (info.file.response.status === SystemContants.STATUS_SUCCESS) {
          info.file.response.data.forEach(value => {
            this.images.push(value);
          });
          let newArr = new Array();
          Object.assign(newArr, this.images);
          this.images = newArr;
          this.msg.success('上传成功');
        } else {
          this.msg.error(info.file.response.error);
        }
        this.uploading = false;
        break;
      case 'error':
        this.msg.error('Network error');
        this.uploading = false;
        break;
    }
  }

  updateOrder() {
    this.http.put<any>('api/app/contract/images', this.images).subscribe((resp) => {
      if (resp.status === SystemContants.STATUS_SUCCESS) {
        this.images.sort((a: any, b: any) => {
          return a.orderIndex - b.orderIndex;
        });
        var newArr = new Array();
        Object.assign(newArr, this.images);
        this.images = newArr;
        this.msg.success('更新成功');
      }
    });
  }

  toCancelCamera() {
    this.showCamera = false;
    this.utilService.checkAndCloseMedisStream();
  }

  toTakePic() {
    let canvas: any = document.getElementById('canvas');
    let context: any = canvas.getContext('2d');
    canvas.width = this.video.videoWidth;
    canvas.height = this.video.videoHeight;
    context.drawImage(this.video, 0, 0);
    const data = {
      url: canvas.toDataURL("image/jpeg"),
      contractId: this.record.id
    };
    this.http.post<any>('api/app/contract/image/base64', data).subscribe((resp) => {
      if (resp.status === SystemContants.STATUS_SUCCESS) {
        this.images.unshift(resp.data);
        this.changeDetectorRef.detectChanges();
      }
    })

  }

  toDelete(id: string) {
    this.http.delete<any>('api/app/contract/image/id/'+id).subscribe((resp) => {
      if (resp.status === SystemContants.STATUS_SUCCESS) {
        this.images.forEach((image, index) => {
          if (image.id === id) {
            this.images.splice(index ,1);
            return;
          }
        });
        this.changeDetectorRef.detectChanges();
      }
    })
  }

  toMaxImage(image: any) {
    this.currentImage = image;
    this.modalService.create({
      nzTitle: '查看图片',
      nzContent: this.maxImageTpl,
      nzWidth: '80%',
      nzFooter: null
    });
  }



}
